import React, { Component } from 'react'
import { isMobile } from 'react-device-detect'
import NavigationBar from './NavigationBar.jsx'

class NavigationBarContainer extends Component {
  changeSettingsPos = () => {
    window.addEventListener('scroll', (e) => {
      document
        .querySelector('.settings')
        .setAttribute('style', `top: calc(8vh - ${window.scrollY}px)`)
    })
  }

  componentDidMount = () => {
    if (isMobile && window.location.pathname == '/trening') {
      this.changeSettingsPos()
      setTimeout(() => {
        document
          .querySelector('.settings')
          .setAttribute('style', 'display: flex;')
      }, 200)
    } else if (isMobile && window.location.pathname !== '/trening') {
      document.querySelector('.settings').setAttribute('style', 'display:none')
    }
  }

  render() {
    return <NavigationBar />
  }
}

export default NavigationBarContainer
